import React, { useCallback, useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';
import { navigate } from '@reach/router';
import moment from 'moment';
import Slider from 'react-slick';

import {
  IGame,
  IGroupEnrollment,
  IGroupGameGame
} from '../../../../../../store/player/games/store';

import { userPic } from '../../../../../../assets/images';
import Button from '../../../../../../components/Button';
import { toHandicap } from '../../../../../../contrib/Utils/toHandicap';
import { LeftArrow } from '../LeftArrow';
import { RightArrow } from '../RightArrow';
import { useShotgunGameMetadata } from './useShotgunGameMetadata';

const settings = {
  arrows: true,
  dots: false,
  infinite: false,
  nextArrow: <RightArrow />,
  prevArrow: <LeftArrow />,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 300
};

interface IProps {
  currentGame: IGame;
}

export const CurrentEventTeeTimeParings = (props: IProps) => {
  const { currentGame } = props;

  const { holeAssignment, isShotgun, eventId } = useShotgunGameMetadata(currentGame);

  const goToLeaderboard = useCallback(() => {
    navigate(`/event/${eventId}/leaderboard`);
  }, [currentGame, eventId]);

  const userEnrollmentId = currentGame && currentGame.enrollment;

  const roundId = currentGame && currentGame.round && currentGame.round.id;

  const userEnrollment: IGroupEnrollment | undefined =
    currentGame &&
    currentGame.group.enrollments.find((g: IGroupEnrollment) => g.id === userEnrollmentId);

  const partners: IGroupEnrollment[] | undefined =
    currentGame &&
    currentGame.group.enrollments.filter((g: IGroupEnrollment) => g.id !== userEnrollmentId);

  const [currentPlayerGame, setCurrentPlayerGame] = useState<IGroupGameGame>();

  useEffect(() => {
    if (userEnrollment) {
      const foundPlayerGame = currentGame.group.games.find(
        game => game.enrollment.id === userEnrollment.id
      );

      if (foundPlayerGame) {
        setCurrentPlayerGame(foundPlayerGame);
      }
    }
  }, [userEnrollment, currentGame]);

  return (
    <Paper elevation={1} className="paper event-info override current-event-tee-time-parings">
      <div className="paper-title override">
        <h2 className="pairings-title override">YOUR TEE TIME AND PARINGS</h2>
      </div>

      {isShotgun ? (
        <div className="time-title">HOLE ASSIGNMENT: {holeAssignment}</div>
      ) : (
        <div className="time-title">{`${
          currentGame ? moment(currentGame.group.start).format('h:mm') : ''
        } TEE TIME`}</div>
      )}

      <div className="handicap-tee">
        <div className="hcp-index">
          <div>{`HCP ${currentGame ? toHandicap(currentGame.handicap) : '-'}`}</div>

          <div>{`INDEX ${
            currentPlayerGame ? toHandicap(currentPlayerGame.enrollment.index) : '-'
          } `}</div>
        </div>

        <div className="tee">
          {userEnrollment && userEnrollment.flight && (
            <div>{`${userEnrollment.flight.name} Flight`}</div>
          )}

          <div>{`${currentGame.currentTee ? currentGame.currentTee.name : 'TBD'} Tee`}</div>
        </div>
      </div>

      <div className="partner-title">PLAYING PARTNERS</div>

      <div className="partners">
        {partners && (
          <Slider
            className="slider-partners"
            {...settings}
            slidesToShow={partners.length < 3 ? partners.length : 3}
          >
            {partners.map((partner: IGroupEnrollment, index: number) => (
              <div className="partner" key={`partner${index}`}>
                <img
                  src={partner.user.profile.image ? partner.user.profile.image : userPic}
                  alt=""
                />

                <div className="name">
                  <div className="first">{`${partner.user.firstName}`}</div>

                  <div className="last">{`${partner.user.lastName}`}</div>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>

      <Button
        id="start-round"
        variant="contained"
        color="primary"
        className="button start-round"
        onClick={() => {
          navigate(`/event-scores/${eventId}/round/${roundId}/set-scorer`);
        }}
      >
        GO TO MY ROUND
      </Button>

      <Button
        id="leaderboards"
        variant="outlined"
        color="primary"
        className="button second"
        onClick={goToLeaderboard}
      >
        EVENT DETAILS
      </Button>
    </Paper>
  );
};
